import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useTheme } from "@mui/material";

import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "1400px",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 3,
  maxHeight: "calc(100vh - 100px)",
  overflow: "scroll",
};

export default function FoodTruckDetailsModal({ open, setOpen, data, index }) {
  const handleClose = () => setOpen(false);
  const theme = useTheme();

  const dataBoxStyle = {
    background: "#DEE6F252",
    width: "100%",
    height: "Hug(55px)px",
    padding: "14px",
    gap: "10px",
    borderRadius: "12px",
    color: "#164FA1",
    fontWeight: "600",
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{ ...style, width: { xs: "90%", md: "calc(100% - 50px)" }, p: 5 }}
        >
          <Box>
            <Box className="flexBetween">
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: { xs: "18px", md: "22px", lg: "26px" },
                  color: theme.palette.text.active,
                }}
              >
                My Booking
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 2, sm: 5 },
                mt: 2,
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  gap: { xs: 2, sm: 5 },
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    gap: { xs: 2, sm: 2 },
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ width: "100%" }}>
                    <Box py={1} sx={{ fontWeight: "500" }}>
                      City Name
                    </Box>
                    <Box sx={dataBoxStyle}>
                      <Typography> {data[index]?.city_name}</Typography>
                    </Box>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Box py={1} sx={{ fontWeight: "500" }}>
                      State
                    </Box>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      {data?.state?.map((x, i) => (
                        <Box
                          key={i}
                          sx={{
                            ...dataBoxStyle,
                            width: "fit-content",
                            m: 0.25,
                          }}
                        >
                          <Typography>{x?.state_name}</Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ width: "100%" }}>
                  <Box py={1} sx={{ fontWeight: "500" }}>
                    Address
                  </Box>
                  <Box
                    sx={{
                      ...dataBoxStyle,
                      height: "160px",
                      overflow: "scroll",
                    }}
                  >
                    <Typography>{data[index]?.address}</Typography>
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 2, sm: 5 },
                mt: 2,
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  gap: { xs: 2, sm: 5 },
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <Box sx={{ width: "100%" }}>
                  <Box py={1} sx={{ fontWeight: "500" }}>
                    Type of Meals
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1.5,
                      width: "100%",
                      flexWrap: "wrap",
                    }}
                  >
                    {data[index]?.booked_meal &&
                      data[index]?.booked_meal?.map((x, i) => (
                        <Box
                          key={i}
                          sx={{ ...dataBoxStyle, width: "fit-content" }}
                        >
                          <Typography>{x?.meal_name}</Typography>
                        </Box>
                      ))}
                  </Box>
                </Box>
                <Box sx={{ width: "100%", visibility: data[index]?.booked_diet?.length > 0 ? 'visible' : "hidden" }}>
                  <Box py={1} sx={{ fontWeight: "500" }}>
                    Diet Type
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1.5,
                      width: "100%",
                      flexWrap: "wrap",
                    }}
                  >
                    {data[index]?.booked_diet &&
                      data[index]?.booked_diet?.map((x, i) => (
                        <Box
                          key={i}
                          sx={{ ...dataBoxStyle, width: "fit-content" }}
                        >
                          <Typography>{x?.diet_name}</Typography>
                        </Box>
                      ))}
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 2, sm: 5 },
                mt: 2,
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  gap: { xs: 2, sm: 5 },
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <Box sx={{ width: "100%" }}>
                  <Box py={1} sx={{ fontWeight: "500" }}>
                    Booking Date
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1.5,
                      width: "100%",
                      flexWrap: "wrap",
                    }}
                  >
                    {[data[index]?.from_date, data[index]?.to_date].map(
                      (x, i) => (
                        <Box
                          key={i}
                          sx={{
                            ...dataBoxStyle,
                            width: "fit-content",
                            display: "flex",
                          }}
                        >
                          <Typography>{x}</Typography>
                          <CalendarMonthRoundedIcon
                            style={{ color: "#F57C00" }}
                          />
                        </Box>
                      )
                    )}
                  </Box>
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    gap: { xs: 2, sm: 2 },
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ width: "100%" }}>
                    <Box py={1} sx={{ fontWeight: "500" }}>
                      Contact Details
                    </Box>
                    <Box sx={dataBoxStyle}>
                      <Typography>{data[index]?.full_name}</Typography>
                    </Box>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Box sx={dataBoxStyle}>
                      <Typography>{data[index]?.email}</Typography>
                    </Box>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Box sx={dataBoxStyle}>
                      <Typography>{data[index]?.phno}</Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 2, sm: 5 },
                mt: 2,
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  gap: { xs: 2, sm: 5 },
                  flexDirection: "row",
                }}
              >
                <Box sx={{ width: "100%" }}>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1.5,
                      width: "100%",
                      flexWrap: "wrap",
                    }}
                  >
                    <Box>
                      <Typography>Persons</Typography>
                      <Box
                        sx={{ ...dataBoxStyle, width: "fit-content", mt: 1 }}
                      >
                        <Typography> {data[index]?.no_of_person}</Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    alignItems: "flex-end",
                    display: "flex",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1.5,
                      width: "100%",
                      flexWrap: "wrap",
                    }}
                  >
                    <Box>
                      <Typography>Budget per person</Typography>
                      <Box
                        sx={{ ...dataBoxStyle, width: "fit-content", mt: 1 }}
                      >
                        <Typography>
                          {data[index]?.budget_per_person}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                borderRadius: "18px",
                my: 2,
                py: 1,
                px: 1.5,
                border: "1px solid #1A130C24",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>Paid Amount</Box>
                <Box
                  className="flexCenter"
                  sx={{
                    background: "#FFF6ED",
                    padding: "18px 24px",
                    borderRadius: "62px",
                    height: "50px",
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "#F57C00",
                  }}
                >
                  € {data[index]?.total_budget}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
